import { useEffect } from "react";
import { Link } from 'react-router-dom';
import StatusProcessing from '../../../../../styles/images/svg/status-processing.svg';
import StatusDelivered from '../../../../../styles/images/svg/status-delivered.svg';
// import StatusReturned from '../../../../../styles/images/svg/status-returned.svg';
import { handleChangeDataModalLogOut } from '../../../../../redux/actions/partials/modals/modalLogOut';
import { handleChangeInputLoginPage } from "../../../../../redux/actions/pages/user/login";
import { handleChangeDataUserOrders } from '../../../../../redux/actions/pages/user/orders';
import { useDispatch, useSelector } from "react-redux";
import { PROFILE_URL } from "../../../../../apis";
import apiRequest from '../../../../../utils/apiRequest';


const SurveyMobile = () => {

	const dispatch = useDispatch();
	const { token, profile, deliveredCountOrder, pendingCountOrder } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);

	const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    const showLogOutModal = () => {
        dispatch(handleChangeDataModalLogOut('isOpen', true));
        setTimeout(() => dispatch(handleChangeDataModalLogOut('isActive', true)), 0);
    };

    useEffect(() => {
    	apiProfile();
    }, []);

    const apiProfile = () => {
    	if(! isBackdropLoading) {

			apiRequest({
			    dispatch,
			    endpoint: PROFILE_URL ,
			    method: 'post',
			    token: token, 
			    onSuccess: (res) => {
			      	dispatch(handleChangeInputLoginPage('deliveredCountOrder', res.orderData.deliveredCount));
			      	dispatch(handleChangeInputLoginPage('pendingCountOrder', res.orderData.pendingCount));
			    },
		  	});
		}
    };

    return (

    	<div className="flex flex-col grow" >


			{/* <div className="sticky top-0 left-0 w-full z-3 bg-neutral-000" id="base_layout_mobile_sticky_header" style={{top: '0px'}}>
				<div>
					<div className="flex items-center justify-between px-5 py-4 sticky top-0 z-2 bg-neutral-000" style={{height: '64px'}}>
						<div className="flex cursor-pointer">
							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
								<use xlinkHref="#setting"></use>
							</svg>
						</div>
						<div className="flex items-center">
							<a className="ml-5" href="/support/">
								<div className="flex">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
										<use xlinkHref="#support"></use>
									</svg>
								</div>
							</a>
							<a className="styles_Link__RMyqc" href="/profile/notification/">
								<div className="flex">
									<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
										<use xlinkHref="#notificationOffOutline"></use>
									</svg>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div> */}

			<div className="grow flex flex-col" style={{paddingBottom: '55px', paddingTop: '0px'}}>
				<div className="styles_BaseLayoutMobile__fixMobileHeader__eilSC">
					<div id="base_layout_mobile_static_header">
					</div>
				</div>
				<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX">
					<div id="profileLayoutContainer" className="relative flex flex-col lg:grid grid-cols-1 lg:grid-cols-7 gap-4 gap-y-0 mt-0  pt-4 pb-6 lg:px-4">
						<div className="lg:col-span-5">
							<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
							</div>
							<div>
								<div className="px-2">
								</div>
								<div className="mx-5 lg:mx-4 lg:py-4 bg-neutral-000 lg:border-complete-b pb-5">
									<div className="flex justify-between items-center mb-2 pb-5 lg:pb-0 styles_ProfileSidebarUserCard__info__gRs23">
										<div className="flex flex-col">
											<p className="text-h5 text-neutral-800">{profile.fname} {profile.lname}
											</p>
											<p className="text-body-1 text-neutral-400 styles_ProfileSidebarUserCard__userPhone__lcCD0">{toPersianDigits(profile.mobile)}
											</p>
										</div>
										<Link className="styles_Link__RMyqc" data-cro-id="profile-edit" to={`personal-info`}>
											<div className="flex">
												<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-secondary)'}}>
													<use xlinkHref="#edit"></use>
												</svg>
											</div>
										</Link>
									</div>

								</div>
							</div>

							<div className="lg:rounded-medium relative styles_Frame__Lu_I7 mb-4 bg-neutral-000 !mb-0">
								<div className="flex justify-between items-center lg:py-4 px-4">
									<div className="break-words py-3">
										<div className="flex items-center grow">
											<p className="grow text-h5 text-neutral-900">
												<span className="relative">سفارش‌های من
												</span>
											</p>
										</div>
										<div className="mt-2 styles_Title__line__KyW9l styles_Title__line--red__TP9mu">
										</div>
									</div>
									<span data-cro-id="profile-all-orders">
										<Link className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-button-2" to={`orders`}>
											<span>مشاهده همه
											</span>
											<div className="flex">
												<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
													<use xlinkHref="#chevronLeft"></use>
												</svg>
											</div>
										</Link>
									</span>
								</div>
								<div className="flex flex-row justify-evenly items-center my-5 lg:pr-6 w-full">
									<Link 
										className="flex flex-col lg:flex-row lg:gap-3 items-center xs:justify-start styles_OrderStatus__3hpHr br-list-horizontal-0" 
										onClick={() => dispatch(handleChangeDataUserOrders('selectedTab', 'pending'))} 
										to={`orders`}
									>
										<div className="relative">
											<div style={{width: '60px', height: '60px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={StatusProcessing} width="60" height="60" alt="icon" title="" style={{objectFit: 'contain'}} />
											</div>
											<div className="absolute left-0 bottom-0 flex items-center justify-center rounded-small text-caption-strong text-neutral-700 styles_OrderStatus__count__3ctvu">
												{toPersianDigits(pendingCountOrder)}
											</div>
										</div>
										<div className="flex flex-col justify-between">
											<span className="text-body2-strong text-neutral-700">جاری
											</span>
										</div>
									</Link>
									<Link 
										className="flex flex-col lg:flex-row lg:gap-3 items-center xs:justify-start styles_OrderStatus__3hpHr br-list-horizontal-0 lg:pr-8" data-cro-id="profile-orders-sent" 
										onClick={() => dispatch(handleChangeDataUserOrders('selectedTab', 'delivered'))} 
										to={`orders/?activeTab=sent`} 
									>
										<div className="relative">
											<div style={{width: '60px', height: '60px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={StatusDelivered} width="60" height="60" alt="icon" title="" style={{objectFit: 'contain'}} />
											</div>
											<div className="absolute left-0 bottom-0 flex items-center justify-center rounded-small text-caption-strong text-neutral-700 styles_OrderStatus__count__3ctvu">
												{toPersianDigits(deliveredCountOrder)}
											</div>
										</div>
										<div className="flex flex-col justify-between">
											<span className="text-body2-strong text-neutral-700">تحویل شده
											</span>
										</div>
									</Link>
									{/*<Link className="flex flex-col lg:flex-row lg:gap-3 items-center xs:justify-start styles_OrderStatus__3hpHr br-list-horizontal-0 lg:pr-8" data-cro-id="profile-orders-returned" to={`orders/?activeTab=returned`} >
										<div className="relative">
											<div style={{width: '60px', height: '60px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={StatusReturned} width="60" height="60" alt="icon" title="" style={{objectFit: 'contain'}} />
											</div>
											<div className="absolute left-0 bottom-0 flex items-center justify-center rounded-small text-caption-strong text-neutral-700 styles_OrderStatus__count__3ctvu">۰
											</div>
										</div>
										<div className="flex flex-col justify-between">
											<span className="text-body2-strong text-neutral-700">مرجوع شده
											</span>
										</div>
									</Link>*/}
								</div>
							</div>
							<div className="lg:rounded-medium relative styles_Frame__Lu_I7 p-0">
								<div className="bg-neutral-000 flex-col lg:pb-2">
									

									<div data-cro-id="profile-sidebar-menu" className="relative px-5 styles_ProfileSidebarMenuItem__YvbVJ">
										<Link className="cursor-pointer py-3 break-words block" to={`orders`}>
											<div className="flex justify-between items-center">
												<div className="flex shrink-0 ml-4">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#order"></use>
													</svg>
												</div>
												<div className="grow text-right">
													<span className="grow text-neutral-700 text-body1-strong">سفارش‌ها
													</span>
													<div>
													</div>
												</div>
												<div className="flex items-center shrink-0 mr-4">
													<div className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</div>
										</Link>
									</div>
									<div data-cro-id="profile-sidebar-menu" className="relative px-5 styles_ProfileSidebarMenuItem__YvbVJ">
										<Link className="cursor-pointer py-3 break-words block border-complete-t" to={"favorites"}>
											<div className="flex justify-between items-center">
												<div className="flex shrink-0 ml-4">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#favoriteOff"></use>
													</svg>
												</div>
												<div className="grow text-right">
													<span className="grow text-neutral-700 text-body1-strong">لیست علاقه‌مندی‌ها
													</span>
													<div>
													</div>
												</div>
												<div className="flex items-center shrink-0 mr-4">
													<div className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</div>
										</Link>
									</div>

									<div data-cro-id="profile-sidebar-menu" className="relative px-5 styles_ProfileSidebarMenuItem__YvbVJ">
										<Link className="cursor-pointer py-3 break-words block border-complete-t" to={`addresses`}>
											<div className="flex justify-between items-center">
												<div className="flex shrink-0 ml-4">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#street"></use>
													</svg>
												</div>
												<div className="grow text-right">
													<span className="grow text-neutral-700 text-body1-strong">آدرس‌ها
													</span>
													<div>
													</div>
												</div>
												<div className="flex items-center shrink-0 mr-4">
													<div className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</div>
										</Link>
									</div>

									{/*<div data-cro-id="profile-sidebar-menu" className="relative px-5 styles_ProfileSidebarMenuItem__YvbVJ">
										<a className="cursor-pointer py-3 break-words block border-complete-t" href="/profile/notification/">
											<div className="flex justify-between items-center">
												<div className="flex shrink-0 ml-4">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#notificationOffOutline"></use>
													</svg>
												</div>
												<div className="grow text-right">
													<span className="grow text-neutral-700 text-body1-strong">پیام‌ها
													</span>
													<div>
													</div>
												</div>
												<div className="flex items-center shrink-0 mr-4">
													<div className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</div>
										</a>
									</div>*/}

									<div data-cro-id="profile-sidebar-menu" className="relative px-5 styles_ProfileSidebarMenuItem__YvbVJ">
										<Link className="cursor-pointer py-3 break-words block border-complete-t" to={`personal-info`}>
											<div className="flex justify-between items-center">
												<div className="flex shrink-0 ml-4">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#profileOff"></use>
													</svg>
												</div>
												<div className="grow text-right">
													<span className="grow text-neutral-700 text-body1-strong">اطلاعات حساب کاربری
													</span>
													<div>
													</div>
												</div>
												<div className="flex items-center shrink-0 mr-4">
													<div className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</div>
										</Link>
									</div>
									<div data-cro-id="profile-sidebar-menu" className="relative px-5 styles_ProfileSidebarMenuItem__YvbVJ">
										<span onClick={showLogOutModal} className="cursor-pointer py-3 break-words block border-complete-t">
											<div className="flex justify-between items-center">
												<div className="flex shrink-0 ml-4">
													<svg style={{width: '24px', height: '24px'}}>
														<use xlinkHref="#registerationSignOut"></use>
													</svg>
												</div>
												<div className="grow text-right">
													<span className="grow text-neutral-700 text-body1-strong">خروج
													</span>
													<div>
													</div>
												</div>
												<div className="flex items-center shrink-0 mr-4">
													<div className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
															<use xlinkHref="#chevronLeft"></use>
														</svg>
													</div>
												</div>
											</div>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


		</div>

    );
}

export default SurveyMobile;